// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.LinkElement_wrapper__tCKzk {
    position: relative;
    background: linear-gradient(180deg,#5b72ab 0,#384588 100%);
    display: block;
    max-width: 100%;
    font-family: museo,sans-serif;
    font-weight: 500;
    border-radius: 4px;
    color: #fff;
    text-align: center;
    box-shadow: 0 1px 8px rgba(16,27,82,.15), inset 0 4px 50px rgba(39,61,255,0);
    transition: .35s;
    border: none;
    padding: 8px;
    font-size: 20px;
    height: 49px;
}`, "",{"version":3,"sources":["webpack://./src/components/LinkElement/LinkElement.module.css"],"names":[],"mappings":";AACA;IACI,kBAAkB;IAClB,0DAA0D;IAC1D,cAAc;IACd,eAAe;IACf,6BAA6B;IAC7B,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,4EAA4E;IAC5E,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,YAAY;AAChB","sourcesContent":["\r\n.wrapper {\r\n    position: relative;\r\n    background: linear-gradient(180deg,#5b72ab 0,#384588 100%);\r\n    display: block;\r\n    max-width: 100%;\r\n    font-family: museo,sans-serif;\r\n    font-weight: 500;\r\n    border-radius: 4px;\r\n    color: #fff;\r\n    text-align: center;\r\n    box-shadow: 0 1px 8px rgba(16,27,82,.15), inset 0 4px 50px rgba(39,61,255,0);\r\n    transition: .35s;\r\n    border: none;\r\n    padding: 8px;\r\n    font-size: 20px;\r\n    height: 49px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `LinkElement_wrapper__tCKzk`
};
export default ___CSS_LOADER_EXPORT___;
